export default "__VITE_ASSET__BsGffSwP__"